// src/utils/mapLayers.js
import TileLayer from 'ol/layer/Tile'
import WMTS from 'ol/source/WMTS'
import { get as getProjection } from 'ol/proj'
import { getWidth, getTopLeft } from 'ol/extent'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import CONFIG from '../config/GIS_Config'

// 1. 投影配置
const projection = getProjection(CONFIG.PROJECTION)
const projectionExtent = projection.getExtent()

/**
 * 创建WMTS瓦片图层
 * @returns {TileLayer} WMTS瓦片图层实例
 */
export function createLayerEM_MAP_ALL_18() {
  // 3. 瓦片网格配置
  const tileGrid = new WMTSTileGrid({
    origin: getTopLeft(projectionExtent),
    resolutions: CONFIG.TILE_MATRIX_SET.RESOLUTIONS,
    matrixIds: CONFIG.TILE_MATRIX_SET.MATRIX_IDS,
    tileSize: CONFIG.TILE_MATRIX_SET.TILE_SIZE,
    extent: projectionExtent,
  })

  const layerConfig = CONFIG.LAYER_PARAMS.SPECIFIC.EM_MAP_LEVEL_18_ST

  // 4. WMTS源配置
  const wmtsSource = new WMTS({
    url: CONFIG.SERVICE_PATHS.WMTS_BASE(CONFIG.WORKSPACE),
    layer: layerConfig.name,
    matrixSet: CONFIG.LAYER_PARAMS.WMTS_BASE.matrixSet,
    format: 'image/png',
    style: '',
    projection: CONFIG.LAYER_PARAMS.WMTS_BASE.projection,
    tileGrid: tileGrid,
    tileUrlFunction: tileCoord => {
      layerConfig.tileUrlTemplate(CONFIG.TILE_MATRIX_SET.ID, ...tileCoord)
    },
    // tileLoadFunction: function (imageTile, src) {
    //   const img = new Image();
    //   img.setAttribute("crossOrigin", "anonymous");
    //   img.onload = function () {
    //     const canvas = document.createElement("canvas");
    //     const w = img.width;
    //     const h = img.height;
    //     canvas.width = w;
    //     canvas.height = h;
    //     const context = canvas.getContext("2d");

    //     // 增强灰亮感的滤镜组合：提高亮度，降低对比度，保留适当灰度层次
    //     context.filter = "grayscale(100%) invert(90%) brightness(90%) contrast(80%)";

    //     context.drawImage(img, 0, 0, w, h, 0, 0, w, h);
    //     imageTile.getImage().src = canvas.toDataURL("image/png");
    //   };
    //   img.src = src;
    // }
  })

  // 5. 创建瓦片图层
  return new TileLayer({
    source: wmtsSource
   })
}
